export enum Priority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}
export enum Status {
  NotStarted = "Not Started",
  InProgress = "In Progress",
  Cancelled = "Cancelled",
  Done = "Done",
}

export const PriorityType = ["All", "Low", "High", "Medium"];
export const StatusType = [
  "All",
  "Not Started",
  "In Progress",
  "Cancelled",
  "Done",
];
export const TimeType = ["All", "Current Month", "Last 3 Months", "Last Year"];
export const FilterData = [
  { label: "TaskName", data: ["All"] },
  { label: "DateRange", data: TimeType },
  { label: "Priority", data: PriorityType },
  { label: "Status", data: StatusType },
];
